import React, { useCallback } from 'react';
import { useMediaQuery } from 'react-responsive';
import PropTypes from 'prop-types';

import { formatNumber } from 'js/components/shared/vehicleFunctions';

import { vehicleTypes } from 'components/rentingRedRac/types';

const Header = ({ t, vehicle, values }) => {
    const isMobile = useMediaQuery({
        maxDeviceWidth: 600,
    });
    const renderItem = useCallback(
        (label, text, important) => (
            <div
                className={`${isMobile ? 'u-1/1' : 'u-1/4'} u-inline-item u-mb`}
            >
                <p className="u-text-muted">{label}</p>
                <p
                    className={`${
                        important ? 'u-text-brand u-text-bold' : 'u-text-base'
                    } u-m-none u-text-truncate`}
                >
                    {text}
                </p>
            </div>
        ),
        [isMobile]
    );
    return (
        <header
            style={{
                display: 'flex',
                alignItems: 'flex-end',
                flexDirection: isMobile ? 'column' : 'row',
            }}
        >
            <div className={`u-1/1`}>
                <p className="u-mb-large u-1/1 u-pb u-text-bold">
                    {`${vehicle.Plate} - ${vehicle.Model}`}
                </p>
                {renderItem(t.getTraduction('Installation'), vehicle.Dealer)}
                {renderItem(
                    t.getTraduction('MinimumSellingImport'),
                    `${formatNumber(vehicle.MinimumPrice.toFixed(2))}€`
                )}
                {renderItem(
                    t.getTraduction('ComercialProduct'),
                    vehicle.ProductName
                )}
                {renderItem(
                    t.getTraduction('PaymentMethod'),
                    t.getTraduction('RentingRedRacPaymentMethods')[
                        values.paymentMethod
                    ]
                )}
                {renderItem(
                    t.getTraduction('SellingImport'),
                    `${formatNumber(values.amount)}€`,
                    true
                )}
                {values.paymentMethod === 'F' && (
                    <>
                        {renderItem(
                            t.getTraduction('EntryAmount'),
                            `${formatNumber(values.baseAmount)}€`,
                            true
                        )}
                        {renderItem(
                            t.getTraduction('FinancialAmount'),
                            `${formatNumber(values.financialAmount)}€`,
                            true
                        )}
                    </>
                )}
                {renderItem(
                    t.getTraduction('Km'),
                    `${formatNumber(values.km)}km`,
                    true
                )}
            </div>
        </header>
    );
};

Header.propTypes = {
    t: PropTypes.shape({
        getTraduction: PropTypes.func.isRequired,
    }),
    vehicle: vehicleTypes,
    values: PropTypes.object.isRequired,
};

export default Header;
